export default "__VITE_ASSET__DFXG4bdF__"